module.exports = __webpack_public_path__ + "static/media/desktopScreenshot02.ff9bb91b.jpg";